module.exports = __webpack_public_path__ + "img/dynamic_jiankong.6ea07c40.png";